import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { from, map } from 'rxjs';

import { AuthInitService } from '@app/core/init/auth-init.service';

/**
 * Executa {@link AuthInitService.initialize} (whoAmI + escolas + termos de uso) **antes**
 * dos guards que dependem de `AppContextService` — o `resolve` roda **depois** de
 * `canActivate`, então não pode ser a única fonte desse carregamento.
 */
export const authInitGuard: CanActivateFn = (_route, state) => {
  const init = inject(AuthInitService);
  const router = inject(Router);

  return from(init.initialize(state.url)).pipe(
    map((result) => result || router.createUrlTree(['/error/401']))
  );
};
